import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../Base";
import { MaskedTextField } from "../../MaskedTextField";

const useStyles = makeStyles({
  container: {
    margin: "20px 0px 0px 20px",
  },
});

export const AddRouteContent = ({ onRouteCodeChange, routeCode, errors }) => {
  const styles = useStyles();
  return (
    <View className={styles.container}>
      <MaskedTextField
        mask={"999"}
        value={routeCode}
        name={"routeCode"}
        label={"Route Code"}
        error={errors["routeCode"]}
        onChange={onRouteCodeChange}
      />
    </View>
  );
};
